import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import MakerAmendmentTable from '../components/MakerAmendmentTable';
import MakerCancellationTable from '../components/MakerCancellationTable';
import MakerLimitDeactivationTable from '../components/MakerLimitDeactivationTable';
import MakerPartnerPermissionTable from '../components/MakerPartnerPermissionTable';
import MakerBusinessKeywordTable from '../components/MakerBusinessKeywordTable';
import MakerHolidayCalendarTable from '../components/MakerHolidayCalendarTable';
import MakerCocCancellationTable from '../components/MakerCocCancellationTable';
interface Props {
  onLogout: () => void;
}
interface TabPanelProps {
  index: number;
  value: number;
  children: React.ReactNode;
}
const TabPanel: React.FC<TabPanelProps> = ({
  index,
  value,
  children
}) => <div hidden={value !== index} data-id="element-3857" data-mp="hlqx3awqz0ui">{value === index && <Box sx={{
    pt: 2.5
  }} data-id="element-3858" data-mp="11th3x05860f1">{children}</Box>}</div>;
const TAB_DEFS = [{
  label: 'Amendments',
  icon: 'lucide:clipboard-edit'
}, {
  label: 'Cancellations',
  icon: 'lucide:clipboard-check'
}, {
  label: 'Limit Changes',
  icon: 'lucide:shield-off'
}, {
  label: 'Partner Permissions',
  icon: 'lucide:sliders-horizontal'
}, {
  label: 'Business Keywords',
  icon: 'lucide:list-filter'
}, {
  label: 'Holiday Calendar',
  icon: 'lucide:calendar-days'
}, {
  label: 'COC Cancellations',
  icon: 'lucide:landmark'
}];
const MakerInboxHub: React.FC<Props> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const theme = useTheme();
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'background.default',
    overflow: 'hidden'
  }} data-id="element-3859" data-mp="47jgcobzn4w8">
      <TopBar onMenuClick={() => setMobileOpen(!mobileOpen)} onLogout={onLogout} title="Maker Inbox" data-id="element-3860" data-mp="3vc9pl2m2j0te" />
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} activePage="maker-approvals" data-id="element-3861" data-mp="3rc9argv24nlt" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: {
        xs: 2,
        sm: 3,
        md: 5
      },
      width: {
        xs: '100%',
        sm: 'calc(100% - 240px)'
      },
      maxWidth: '100%',
      ml: 0,
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-3862" data-mp="3gp19pohte7b3">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-3863" data-mp="37r8uekc3eznp">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-3864" data-mp="3cor62ihhvsze">
            <Icon icon="lucide:inbox" width={28} height={28} color="#0EA5E9" data-id="element-3865" data-mp="3cp0sxx78tk0v" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-3866" data-mp="4a8tc3glzp9g">Maker Inbox</Typography>
          </Box>

          <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto" sx={{
          mb: 1,
          borderBottom: `1px solid ${theme.palette.divider}`
        }} data-id="element-3867" data-mp="8cn7495f7ytv">
            {TAB_DEFS.map(t => <Tab key={t.label} label={<Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }} data-id="element-3869" data-mp="n5ytrm8w8dl8"><Icon icon={t.icon} width={16} height={16} data-id="element-3870" data-mp="rzbidwdkokdz" /><Typography variant="body2" fontWeight={700} data-id="element-3871" data-mp="s0cw68lz3kze">{t.label}</Typography></Box>} data-id="element-3868" data-mp="n68nnkx274w7" />)}
          </Tabs>

          <TabPanel value={tab} index={0} data-id="element-3872" data-mp="xc06ibw5tpq2"><MakerAmendmentTable data-id="element-3873" data-mp="xayrjwc0wj32" /></TabPanel>
          <TabPanel value={tab} index={1} data-id="element-3874" data-mp="x9xdrk3mhihn"><MakerCancellationTable data-id="element-3875" data-mp="1b3ohucyl4a5z" /></TabPanel>
          <TabPanel value={tab} index={2} data-id="element-3876" data-mp="1b2d8zyqa8c80"><MakerLimitDeactivationTable data-id="element-3877" data-mp="16424m3iratx6" /></TabPanel>
          <TabPanel value={tab} index={3} data-id="element-3878" data-mp="164lkzfsrda93"><MakerPartnerPermissionTable data-id="element-3879" data-mp="166eh415qwc2u" /></TabPanel>
          <TabPanel value={tab} index={4} data-id="element-3880" data-mp="ifisfcwl5wzt"><MakerBusinessKeywordTable data-id="element-3881" data-mp="ier5srkyv9lo" /></TabPanel>
          <TabPanel value={tab} index={5} data-id="element-3882" data-mp="ede5ex0n7ym5"><MakerHolidayCalendarTable data-id="element-3883" data-mp="eegs0sqxnew9" /></TabPanel>
          <TabPanel value={tab} index={6} data-id="element-3884" data-mp="scdrbwwrtzem"><MakerCocCancellationTable data-id="element-3885" data-mp="sdosdoyu0t21" /></TabPanel>
        </Box>
      </Box>
    </Box>;
};
export default MakerInboxHub;